import { PiMagnifyingGlass } from 'react-icons/pi'
import { useNavigate } from 'react-router-dom'

interface SearchBarProps {
  className?: string
}

export function SearchBar({ className = '' }: SearchBarProps) {
  const navigate = useNavigate()

  const handleSearchClick = () => {
    const currentPath = window.location.pathname
    const currentSearch = window.location.search
    const params = new URLSearchParams(currentSearch)
    params.set('search', 'true')
    navigate(`${currentPath}?${params.toString()}`)
  }

  return (
    <div
      className={`relative w-64 h-8 pl-10 pr-4 bg-[#B4CBC1] rounded-lg text-xs font-light text-gray-700 cursor-pointer hover:bg-[#E6EEEA] focus:outline-none focus:ring-2 focus:ring-gray-300 flex items-center ${className}`}
      onClick={handleSearchClick}
    >
      <PiMagnifyingGlass className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4 flex-shrink-0" />
      <span className="text-gray-700 select-none truncate text-base font-light">
        Search First Bite
      </span>
    </div>
  )
}
